'use client';

import type { FC, InputHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const inputVariants = cva(
  'w-full bg-surface-input border border-border-subtle rounded-xl text-white font-[inherit] transition-[border-color] duration-200 focus:outline-none focus:border-accent-blue disabled:opacity-60 disabled:cursor-not-allowed placeholder:text-subtle',
  {
    variants: {
      size: {
        s: 'px-3 py-2 text-sm',
        m: 'px-4 py-3 text-base',
        l: 'px-5 py-3.5 text-lg',
      },
    },
    defaultVariants: {
      size: 'm',
    },
  },
);

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  size?: 's' | 'm' | 'l';
  multiline?: false;
};

type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'> & {
  size?: 's' | 'm' | 'l';
  multiline: true;
};

export const Input: FC<InputProps | TextareaProps> = (props) => {
  if (props.multiline) {
    const { size = 'm', className, multiline: _multiline, ...rest } = props;
    return <textarea className={cn(inputVariants({ size }), className, 'resize-none')} {...rest} />;
  }

  const { size = 'm', className, multiline: _multiline, ...rest } = props;
  return <input className={cn(inputVariants({ size }), className)} {...rest} />;
};
